import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Button, Stack, Typography, useTheme } from '@mui/material'
import React from 'react'
import { TextField } from 'src/Libs/inputs/formik'
import useLabeledPhotovoltaicOptions from 'src/Libs/installation-statement/hooks/use-labled-photovoltaic-options'
import { Select as ShellSelect } from '@e3dc-react/shell/Elements/Select'
import { useFormikContext } from 'formik'
import { DEFAULT_PHOTOVOLTAIC_STRING_DATA, PhotovoltaicFormData } from 'src/Libs/installation-statement/configurations/photovoltaic'

interface Props {
  index: number
  label: string
  numberOfStrings: number
  duplicateTracker: () => void
}

/**
 * This component displays all fields relevant for a tracker
 */
const TrackerFields: React.FC<Props> = ({ index, label, numberOfStrings, duplicateTracker }) => {
  const { t } = useCustomTranslation()
  const theme = useTheme()
  const { stringCountOptions } = useLabeledPhotovoltaicOptions()
  const { setFieldValue, values } = useFormikContext<PhotovoltaicFormData>()

  const changeNumberOfStrings = (newValue: number): void => {
    const currentTracker = values.pvTrackers[index]
    const firstString = currentTracker?.pvStrings[0]

    if (!firstString) {
      return
    }

    const newValues = Array.from({ length: newValue }, (_, i) => {
      if (i === 0) {
        return currentTracker.pvStrings[i] || firstString
      } else {
        return currentTracker.appliedToAllString ? { ...firstString } : DEFAULT_PHOTOVOLTAIC_STRING_DATA
      }
    })

    setFieldValue(`pvTrackers.[${index}].pvStrings`, newValues)
  }

  return (
    <Stack spacing={theme.spacing(4)}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', pt: 4 }}>
        <Typography variant="h5">{label}</Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button onClick={duplicateTracker}>{t('installation-statement.photovoltaic.form.tracker.duplicate')}</Button>
        </Box>
      </Box>
      <TextField required name={`pvTrackers.[${index}].name`} label={t('installation-statement.photovoltaic.form.tracker.name')} />
      <ShellSelect
        label={`${t('installation-statement.photovoltaic.form.tracker.string-count')}`}
        value={stringCountOptions[numberOfStrings - 1].value}
        options={stringCountOptions}
        onChange={changeNumberOfStrings}
        menuShouldBlockScroll={false}
      />
    </Stack>
  )
}

export default TrackerFields
